import { render, staticRenderFns } from "./OndeEncontrar.vue?vue&type=template&id=2fa013fb&scoped=true&lang=pug"
import script from "./OndeEncontrar.vue?vue&type=script&lang=js"
export * from "./OndeEncontrar.vue?vue&type=script&lang=js"
import style0 from "./OndeEncontrar.styl?vue&type=style&index=0&id=2fa013fb&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa013fb",
  null
  
)

export default component.exports